import React from 'react';

import ProtectionIcon from '@/assets/pretection.svg?react';
import { UiTypography } from '@/components/ui/Typography';
import { webCampaign } from '@/modules/webCampaign';
import { PaymentPlatformsIcons } from '@/pages/Paywall/components/PaymentPlatformsIcons';
import { PaymentProtections } from '@/pages/Paywall/components/PaymentProtections';

import {
  ContentStyles,
  PaywallGuaranteePeriodStyles,
  ProtectionIconWrapperStyles,
} from './GuaranteePeriod.styles';

interface PaywallGuaranteePeriodProps {
  theme?: 'dark-violet' | 'domination' | 'dark-forest' | null;
}

export const PaywallGuaranteePeriod: React.FC<PaywallGuaranteePeriodProps> = ({
  theme,
}) => {
  return (
    <PaywallGuaranteePeriodStyles theme={webCampaign.getStaticTheme()}>
      <ContentStyles>
        <Description />

        <PaymentProtections theme={theme} />

        <PaymentPlatformsIcons />
      </ContentStyles>
    </PaywallGuaranteePeriodStyles>
  );
};

function Description() {
  const termsLink = webCampaign.getLegalTermsLink();

  return (
    <>
      <ProtectionIconWrapperStyles>
        <ProtectionIcon
          style={{
            width: '32px',
            height: '32px',
          }}
        />
      </ProtectionIconWrapperStyles>
      <UiTypography
        component="h3"
        className="content-title"
        align="center"
        variant="title-large"
      >
        14-day Money-back Guarantee
      </UiTypography>
      <UiTypography
        className="content-text"
        align="center"
        color="neutral-black"
      >
        We believe that you will immerse yourself in this thrilling journey,
        find characters that resonate with you perfectly, and experience the
        very emotions you came for. *Applicable if{' '}
        <a href={termsLink} target="_blank">
          Refund policy
        </a>{' '}
        conditions are met.
      </UiTypography>
    </>
  );
}
